export const UnidadesMedida=[
    {codigo:'4A',unidad:'BOBINAS'},
    {codigo:'BJ',unidad:'BALDE'},
    {codigo:'BLL',unidad:'BARRILES'},
    {codigo:'BG',unidad:'BOLSA'},
    {codigo:'BO',unidad:'BOTELLAS'},
    {codigo:'BX',unidad:'CAJA'},
    {codigo:'CT',unidad:'CARTONES'},
    {codigo:'CMK',unidad:'CENTÍMETRO CUADRADO'},
    {codigo:'CMQ',unidad:'CENTÍMETRO CÚBICO'},
    {codigo:'CMT',unidad:'CENTÍMETRO LINEAL'},
    {codigo:'CEN',unidad:'CIENTO DE UNIDADES'},
    {codigo:'CY',unidad:'CILINDRO'},
    {codigo:'CJ',unidad:'CONOS'},
    {codigo:'DZN',unidad:'DOCENA'},
    {codigo:'DZP',unidad:'DOCENA POR 10**6'},
    {codigo:'BE',unidad:'FARDO'},
    {codigo:'GLI',unidad:'GALÓN INGLÉS (4.545956 L)'},
    {codigo:'GRM',unidad:'GRAMO'},
    {codigo:'GRO',unidad:'GRUESA'},
    {codigo:'HLT',unidad:'HECTOLITRO'},
    {codigo:'LEF',unidad:'HOJA'},
    {codigo:'SET',unidad:'JUEGO'},
    {codigo:'KGM',unidad:'KILOGRAMO'},
    {codigo:'KTM',unidad:'KILOMETRO'},
    {codigo:'KWH',unidad:'KILOVATIO HORA'},
    {codigo:'KT',unidad:'KIT'},
    {codigo:'CA',unidad:'LATAS'},
    {codigo:'LBR',unidad:'LIBRAS'},
    {codigo:'LTR',unidad:'LITRO'},
    {codigo:'MWH',unidad:'MEGAWATT HORA'},
    {codigo:'MTR',unidad:'METRO'},
    {codigo:'MTK',unidad:'METRO CUADRADO'},
    {codigo:'MTQ',unidad:'METRO CÚBICO'},
    {codigo:'MGM',unidad:'MILIGRAMOS'},
    {codigo:'MLT',unidad:'MILILITRO'},
    {codigo:'MMT',unidad:'MILÍMETRO'},
    {codigo:'MMK',unidad:'MILÍMETRO CUADRADO'},
    {codigo:'MMQ',unidad:'MILÍMETRO CÚBICO'},
    {codigo:'MLL',unidad:'MILLARES'},
    {codigo:'UM',unidad:'MILLÓN DE UNIDADES'},
    {codigo:'ONZ',unidad:'ONZAS'},
    {codigo:'PF',unidad:'PALETAS'},
    {codigo:'PK',unidad:'PAQUETE'},
    {codigo:'PR',unidad:'PAR'},
    {codigo:'FOT',unidad:'PIES'},
    {codigo:'FTK',unidad:'PIES CUADRADOS'},
    {codigo:'FTQ',unidad:'PIES CÚBICOS'},
    {codigo:'C62',unidad:'PIEZAS'},
    {codigo:'PG',unidad:'PLACAS'},
    {codigo:'ST',unidad:'PLIEGO'},
    {codigo:'INH',unidad:'PULGADAS'},
    {codigo:'RM',unidad:'RESMA'},
    {codigo:'DR',unidad:'TAMBOR'},
    {codigo:'STN',unidad:'TONELADA CORTA'},
    {codigo:'LTN',unidad:'TONELADA LARGA'},
    {codigo:'TNE',unidad:'TONELADAS'},
    {codigo:'TU',unidad:'TUBOS'},
    {codigo:'NIU',unidad:'UNIDAD (BIENES)'},
    {codigo:'ZZ',unidad:'UNIDAD (SERVICIOS)'},
    {codigo:'GLL',unidad:'US GALÓN (3.7843 L)'},
    {codigo:'YRD',unidad:'YARDA'},
    {codigo:'YDK',unidad:'YARDA CUADRADA'}
];

export function ObtenerNombreMedida({codigo}){
    const elemento = UnidadesMedida.filter(medida => medida.codigo == codigo)[0];
    return elemento.unidad;
}

export function ListaUnidadesMedida() {
    const lista = UnidadesMedida.map((i) => (
        <option key={i.codigo} value={i.codigo}>
        {i.unidad+' - '+i.codigo}
        </option>
        ));
    return lista;
}